module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-shooting-cn.f39fb804.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-shooting-cn.png
// module id = 2827
// module chunks = 11